export default {
  'periodic-subscription:main-title': 'REGELMATIG LATEN LEVEREN',
  'periodic-subscription:descripton':
    'Met een abonnement geniet je van alle voordelen van onze talrijke producten - van voeding tot accessoires voor je huisdier.',
  'periodic-subscription:why-subscribe': 'WAAROM AANMELDEN?',
  'periodic-subscription:manage-subscription': 'EENVOUDIG JE ABONNEMENT BEHEREN',
  'periodic-subscription:manage-subscription-description':
    'Je regelmatige leveringen kun je heel eenvoudig met slechts een paar klikken aanpassen in je account onder “Mijn account”.',
  'periodic-subscription:subscribe-benefit': 'MELD JE NU AAN EN PROFITEER',
};
